<div class="container">

  <div class="row">
    <img width="300" src="./assets/images/jeans-logo.png" />
  </div>
  <div class="row">
    <button mat-raised-button color="primary" (click)="tryGoogleLogin()">Login with Google</button>

    <!-- <button mat-raised-button color="primary" (click)="tryTwitterLogin()">Login with Twitter</button> -->
  </div>
</div>
